import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight, Github } from 'lucide-react';
import { Badge } from './ui/badge';

const ProjectCard = ({ project }) => {
  const statusColors = {
    'Completed': 'bg-green-500/10 text-green-400 border-green-500/20',
    'In Progress': 'bg-amber-500/10 text-amber-400 border-amber-500/20'
  };

  return (
    <div className="group bg-neutral-900/50 border border-neutral-800 rounded-lg overflow-hidden hover:border-neutral-700 transition-all hover:translate-y-[-4px]">
      {/* Project Thumbnail Placeholder */}
      <div className="aspect-video bg-gradient-to-br from-neutral-800 to-neutral-900 flex items-center justify-center">
        <div className="text-6xl font-mono text-neutral-700">{project.title.charAt(0)}</div>
      </div>

      {/* Content */}
      <div className="p-6">
        <div className="flex items-start justify-between mb-3">
          <div>
            <h3 className="text-xl font-semibold text-white mb-1 group-hover:text-cyan-400 transition-colors">
              {project.title}
            </h3>
            <p className="text-sm text-neutral-400">{project.subtitle}</p>
          </div>
          <Badge className={statusColors[project.status]}>
            {project.status}
          </Badge>
        </div>

        <p className="text-neutral-300 text-sm mb-4 line-clamp-2">{project.description}</p>

        {/* Tags */}
        <div className="flex flex-wrap gap-2 mb-4">
          {project.tags.slice(0, 4).map((tag, index) => (
            <span
              key={index}
              className="px-2 py-1 text-xs font-medium bg-neutral-800 text-neutral-300 rounded border border-neutral-700"
            >
              {tag}
            </span>
          ))}
        </div>

        {/* Actions */}
        <div className="flex items-center gap-3">
          <Link
            to={`/projects/${project.id}`}
            className="flex items-center gap-1 text-sm font-medium text-cyan-400 hover:text-cyan-300 transition-colors"
          >
            View Details
            <ArrowUpRight size={16} />
          </Link>
          {project.github && (
            <a
              href={project.github}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-1 text-sm font-medium text-neutral-400 hover:text-white transition-colors"
            >
              <Github size={16} />
              Code
            </a>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProjectCard;
